<template>
    <modal style="z-index: 9999;" :show.sync="showModal"
           :show-close=false>
        <template slot="header">
            <h2 class="modal-title" id="exampleModalLabel">Profil wählen</h2>
        </template>
        <div>
            <AddProfile ref="addprofile" :addprofile="profiles < 1"></AddProfile>
            <div class="table-responsive">
                <base-table thead-classes="thead-light"
                            tbody-classes="light"
                            table-classes="scrollable"
                            :data="profiles">
                    <template slot="columns">
                        <th>Profil</th>
                        <th></th>
                    </template>
                    <template v-slot="{row}">
                        <th scope="row">
                            <div v-if="$store.getters['profiles/isLoading']" class="loading"> </div><div v-else>{{ row.name }}</div>
                        </th>
                        <td>
                            <div v-if="$store.getters['profiles/isLoading']" class="loading-button"> </div><div v-else><base-button icon="ni ni-check-bold" size="sm" type="primary" @click="setProfile(row)"></base-button></div>
                        </td>
                    </template>
                </base-table>
            </div>
        </div>
    </modal>
</template>
<script>
    import AddProfile from "@/views/Profiles/AddProfile";

    export default {
        name: 'ChangeProfile',
        components: {AddProfile},
        data() {
            return {
                addprofile: false,
                isLoading: false
            }
        },
        created() {
          if (this.$store.getters['profiles/showActiveProfile'] === null && !this.$store.getters['profiles/isLoading']) this.$store.dispatch('profiles/getProfiles');
        },
        computed: {
            profiles() {
                return (!this.$store.getters['profiles/isLoading']) ? this.filterProfiles(this.$refs.addprofile.model.name) : [{name: 'xxx'}];
            },
            showModal() {
                return this.$store.getters['profiles/showActiveProfile'] === null;
            }
        },
        methods: {
            setProfile(active) {
                this.$store.dispatch('profiles/setActiveProfile', active);
            },
            filterProfiles(name) {
                return Array.from(this.$store.getters['profiles/showProfiles']).filter(item => { return item.name.toLowerCase().includes(name.toLowerCase()) && item.isActive})
            }
        }
    }
</script>

<style>
    ul#multisperrid{height:200px; }
    ul#multisperrid{overflow:hidden; overflow-y:scroll;}
</style>